export enum DwUserActivityNames {
	Tasks = 'tasks',
	PlanList = 'plan_list',
	PlansCompare = 'plans_compare',
	PlanEdit = 'plan_edit',
	PlanView = 'plan_view',
	PlanogramList = 'planogram_list',
	PlacePredict = 'product_place_predict',
	PlanogramsCompare = 'planograms_compare',
	PlanogramEdit = 'planogram_edit',
	PlanogramView = 'planogram_view',
	EquipmentList = 'equipment_list',
	EquipmentEdit = 'equipment_edit',
	EquipmentView = 'equipment_view',
	EquipmentUpload = 'equipment_upload',
	ProductList = 'product_list',
	AnalyticComplex = 'analytic_complex',
	AnalyticLaidProducts = 'analytic_laid_products',
    AnalyticProductHoles = 'analytic_product_holes',
	BIDashboards = 'dashboards',
	Control = 'ph-control',
	CheckPhotoReport = 'check_photo_report',
	PlanogramExecution = 'planogram_execution',
	ProductsForLayout = 'products_for_layout',
	ProductsToRemove = 'products_to_remove',
	ProductHoles = 'products_holes',
	OutOfStock = 'out_of_stock',
	NotLaidOutProducts = 'not_laid_out_products',
	CompletedPlanograms = 'completed_planograms',
	PlanogramsOnExecution = 'planograms_on_execution',
	StorePlans = 'feature_group_store_plans',
	Planograms = 'planogram',
	Products = 'products',
	Equipment = 'instrument',
	DiscreteDistribution = 'discrete_distribution',
	SquareAnalysis = 'square_analysis',
	VisitorHeatmap = 'visitor_heatmap',
	LaidProductsReport = 'laid_products_report',
	SendToExecution = 'send_to_execution',
	LostSalesReport = 'lost_sales_title',
	ABCAnalysis = 'abc_analysis_group',
	StockAnalysis = 'stock_analysis',
	ProductEfficiencyAnalysis = 'product_efficiency_analysis'
}